import React from "react";
import styles from "./_css/searchBar.module.css";
import clsx from "clsx";
import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";
import { SearchBarGeoZoneAndProperties } from "properties/searchBar/SearchBarGeoZoneAndProperties";

type Props = {
    purpose: PROPERTY_PURPOSE;
    value?: string;
    onChange?: (value: string) => void;
};

export default function SearchBar(props: Props) {
    return (
        <div className={clsx(styles.container, "flex-1")}>
            <SearchBarGeoZoneAndProperties isHomePage purpose={props.purpose} />
        </div>
    );
}
